import { useState } from 'react';
import api from '../../services/api';

// Elemento flutuante TEMPORÁRIO: informa o nome do arquivo (.csv) do Released Money
// report; o backend baixa, parseia e salva os lançamentos do extrato MP.
export default function ReleaseReportImporter() {
    const [open, setOpen] = useState(false);
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [recent, setRecent] = useState(null);

    const doImport = async () => {
        const name = fileName.trim();
        if (!name) return;
        setLoading(true);
        setError(null);
        setResult(null);
        try {
            setResult(await api.importReleaseReport(name));
        } catch (e) {
            setError(e.message || 'Falha ao importar');
        } finally {
            setLoading(false);
        }
    };

    const loadRecent = async () => {
        setError(null);
        try {
            const list = await api.listReleaseReports({ limit: 10 });
            setRecent((list.results || []).filter((r) => /\.csv$/i.test(r.file_name || '')));
        } catch (e) {
            setError(e.message || 'Falha ao listar');
        }
    };

    if (!open) {
        return (
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="fixed bottom-5 right-5 z-50 rounded-full bg-[#3483fa] px-4 py-3 text-sm font-semibold text-white shadow-lg hover:opacity-90"
                title="Importar extrato MP (temporário)"
            >
                ⬇ Importar extrato MP
            </button>
        );
    }

    return (
        <div className="fixed bottom-5 right-5 z-50 w-[380px] max-w-[92vw] rounded-xl border border-mono-200 bg-white p-4 shadow-2xl dark:border-mono-700 dark:bg-mono-900">
            <div className="mb-2 flex items-center justify-between">
                <span className="text-sm font-bold">
                    Importar extrato MP <span className="text-xs font-normal text-amber-600">(temporário)</span>
                </span>
                <button type="button" onClick={() => setOpen(false)} className="text-mono-400 hover:text-mono-700">
                    ✕
                </button>
            </div>
            <p className="mb-2 text-xs text-mono-500">
                Nome do arquivo (.csv) do Released Money report. O backend baixa, parseia e salva os lançamentos.
            </p>
            <input
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
                placeholder="reserve-release-...-2026-06-23-134749.csv"
                className="mb-2 w-full rounded-lg border border-mono-300 px-3 py-2 font-mono text-xs dark:border-mono-600 dark:bg-mono-800"
            />
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={doImport}
                    disabled={loading}
                    className="flex-1 rounded-lg bg-[#3483fa] px-3 py-2 text-sm font-semibold text-white disabled:opacity-50"
                >
                    {loading ? 'Importando…' : 'Importar'}
                </button>
                <button type="button" onClick={loadRecent} className="rounded-lg border border-mono-300 px-3 py-2 text-sm dark:border-mono-600">
                    Recentes
                </button>
            </div>
            {error ? <p className="mt-2 text-xs text-red-600">{error}</p> : null}
            {result ? (
                <div className="mt-2 rounded-lg bg-green-50 p-2 text-xs text-green-800 dark:bg-green-900/30 dark:text-green-300">
                    OK: {result.total_rows} linhas · {result.inserted} novas · {result.with_order} com order
                </div>
            ) : null}
            {recent ? (
                <div className="mt-2 max-h-44 overflow-y-auto text-xs">
                    {recent.length === 0 ? (
                        <p className="text-mono-400">Nenhum .csv recente.</p>
                    ) : (
                        recent.map((r) => (
                            <button
                                key={r.id}
                                type="button"
                                onClick={() => {
                                    setFileName(r.file_name);
                                    setRecent(null);
                                }}
                                className="block w-full truncate rounded px-2 py-1 text-left font-mono hover:bg-mono-100 dark:hover:bg-mono-800"
                                title={`${r.begin_date} → ${r.end_date}`}
                            >
                                {r.file_name}
                            </button>
                        ))
                    )}
                </div>
            ) : null}
        </div>
    );
}
